package com.yogaaicoach

import react.create
import react.dom.client.createRoot
import web.dom.ElementId
import web.dom.document

fun main() {
    val container = document.getElementById(ElementId("reactRoot")) ?: document.body
    createRoot(container).render(AppRoot.create())
}
